module.exports = __webpack_public_path__ + "static/media/keyword-count-ratio.0fb19ffa.svg";